import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { removeItem } from '../../Redux/actions/itemsAction';
// import { selectedItemReducer } from '../../Redux/reducers/itemReducer';

const styles = (theme) => ({
    root: {
        margin: 0,
        marginLeft: "15px",
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        marginLeft: "30px",
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        marginLeft: "20px",
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

export default function CustomizedDialogs() {
    const [open, setOpen] = React.useState(true);
    const dispatch = useDispatch();
    const item = useSelector((state) => state.item);

    const handleClose = () => {
        dispatch(removeItem())
        setOpen(false);
    };

    return (
        <div>
            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {item.word}
                </DialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        {item.lexicalCategory} <br />
                        Origine: {item.etymologies}
                    </Typography>
                    <Typography gutterBottom>
                        <b>{item.subsenseDef}</b> <br />
                        <ul>
                            <li>{item.list} </li>
                        </ul>
                    </Typography>
                    <Typography gutterBottom>
                        <b>{item.definitionData} </b><br />
                        <ul>
                            <li>{item.listtwo} </li>
                            <li>{item.listthree} </li>
                        </ul>
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}